let data46;
if (typeof window === "undefined") {
  data46 = require("../static-s46/Data.json");
} else {
  data46 = window.data46;
}

export { data46 };

